import { FC, memo } from 'react'

import { useNavigate } from '@tanstack/react-router'
import { IconName, SymbolBadge } from 'ui/components/'

import { AlertedItemProps } from './AlertedItemProps'

import * as SC from './styles'

export const AlertedItem: FC<AlertedItemProps> = memo((props) => {
  const { isPast = false, isIncomplete = false, overallCount, daysDue, url } = props
  const navigate = useNavigate()

  const pushTo = (link: string) => {
    navigate({ to: link })
  }

  return (
    <SC.Item onClick={() => pushTo(url)}>
      <SC.FirstRow>
        <SC.OverallCount>{overallCount}</SC.OverallCount>
      </SC.FirstRow>
      <SC.LastRow>
        {isPast && (
          <SC.SymbolWrapper>
            <SymbolBadge color={'warning'} icon={IconName.WARNING_FILLED} />
            Past
          </SC.SymbolWrapper>
        )}
        {isIncomplete && (
          <SC.SymbolWrapper>
            <SymbolBadge color={'grey'} icon={IconName.EDIT_OUTLINE} />
            Incomplete
          </SC.SymbolWrapper>
        )}
        {!isIncomplete && !isPast && (
          <SC.SymbolWrapper>
            <SymbolBadge color={'grey'} icon={IconName.CLOCK_TIME_OUTLINE} />
            {daysDue} days
          </SC.SymbolWrapper>
        )}
        <SC.GoToIcon name={IconName.SCHEVRON_RIGHT} />
      </SC.LastRow>
    </SC.Item>
  )
})
